
import LazyHydrate from "vue-lazy-hydration";
import BannerForm from "~/components/roadshow-taiwan/BannerForm.vue";
import ProjectsGeneric from "~/components/roadshow-taiwan/Projects.vue";
import AgentsGeneric from "~/components/roadshow-taiwan/Agents.vue";
import FooterGeneric from "~/components/roadshow-taiwan/Footer.vue";

export default {
    components: {
        FooterGeneric,
        AgentsGeneric,
        ProjectsGeneric,
        BannerForm,
        LazyHydrate,
    },
    data() {
        return {
            step: null,
            selectedDate: null,
            selectedPlace: null,
        };
    },
    methods: {
        handleUpdateStep({ step, selectedDate, selectedPlace }) {
            this.step = step;
            this.selectedDate = selectedDate;
            this.selectedPlace = selectedPlace;
        },
    },
    layout: "empty",
    head() {
        return {
            title: this.$t("LANDINGS.ROADSHOW.META_DATA.TITLE"),
            meta: [
                {
                    name: "title",
                    hid: "title",
                    content: "Thrivestate 巡迴展 - 獨家房地產投資機會",
                },
                {
                    name: "og:title",
                    hid: "og:title",
                    content: "Thrivestate 巡迴展 - 獨家房地產投資機會",
                },
                {
                    name: "description",
                    hid: "description",
                    content:
                        "參加 Thrivestate 巡迴展，探索獨家房地產投資機會！瞭解優質建案，與杜拜房地產專家交流，學習如何投資這個高速成長的市場！機會難得，立即報名！",
                },
                {
                    name: "og:description",
                    hid: "og:description",
                    content:
                        "參加 Thrivestate 巡迴展，探索獨家房地產投資機會！瞭解優質建案，與杜拜房地產專家交流，學習如何投資這個高速成長的市場！機會難得，立即報名！",
                },
            ],
        };
    },
};
